module.exports = __webpack_public_path__ + "static/homepage_dashboard-f7ced11c30ce808d8c890a64cc66d089.png";